import nativePie from './native';
import updateApp from '@/components-new/update-app/index.js';
import store from '@/store';
// import adjustMap from './adjust-map';
import { getCallFn, setCallFn } from './nativecall';
import GlobalAmount from '@/components/common/amount/global-amount';
import Reload from '@/components/common/reload';
import i18n from '@/i18n';
import { isSingleCoin } from '@/i18n/currency';
import * as $http from '@/axios';
import { Dialog } from 'vant';
import MyLog from '@/script/my-log.js';
import { LocalStorageEventName } from '@/script/localStorage';

class Base {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    // 默认执行
    /**
     * Date 原型添加 $format 方法
     * new Date().$format('yyyy-MM-dd hh:mm:ss')
     * new Date().$format('yyyy-MM-dd hh:mm')
     * new Date().$format('yyyy-MM-dd hh:mm:ss.S')
     */
    // eslint-disable-next-line
    Date = (function(Date) {
      myDate.now = Date.now;
      myDate.parse = Date.parse;
      myDate.prototype = Date.prototype;
      myDate.prototype.$format = function(date) {
        const obj = {
          'M+': this.getMonth() + 1,
          'd+': this.getDate(),
          'h+': this.getHours(),
          'm+': this.getMinutes(),
          's+': this.getSeconds(),
          S: this.getMilliseconds()
        };
        if (/(y+)/.test(date)) {
          date = date.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
          );
        }
        for (const key in obj) {
          if (new RegExp('(' + key + ')').test(date)) {
            date = date.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? obj[key]
                : ('00' + obj[key]).substr(('' + obj[key]).length)
            );
          }
        }
        return date;
      };
      return myDate;

      function myDate() {
        // 当只有一个参数并且参数类型是字符串时，把字符串中的-替换为/
        if (arguments.length === 1) {
          const arg = arguments[0];
          if (
            Object.prototype.toString.call(arg) === '[object String]' &&
            arg.indexOf('T') === -1
          ) {
            arguments[0] = arg.replace(/-/g, '/');
          }
        }
        const bind = Function.bind;
        const unbind = bind.bind(bind);
        // eslint-disable-next-line new-parens
        return new (unbind(Date, null).apply(null, arguments))();
      }
    })(Date);

    this.nativePie = nativePie;
    this.updateApp = updateApp;
    this.getCallFn = getCallFn;
    this.setCallFn = setCallFn;
  }

  // 是否从官方下载的app
  get isDownloadFromOfficial() {
    return localStorage.getItem('STORAGE_CHANNEL') === 'official';
  }

  // nicee下載地址（各端商店）
  get AppDownloadUrl() {
    return {
      iOS: {
        app: process.env.VUE_APP_APP_STORE_URL,
        web: process.env.VUE_APP_APP_STORE_WEB_URL
      },
      android: {
        app: process.env.VUE_APP_GOOGLE_STORE_URL,
        web: process.env.VUE_APP_APP_GOOGLE_WEB_URL,
        official: process.env.VUE_APP_ANDROID_APP_URL // 官网下载地址
      }
    };
  }

  /**
   * @description 獲取買送最大送單數
   * @param Object { orderNum, giftAway }
   */
  getMaxSend(orderNum, giftAway) {
    /**
     * Number orderNum-- - 背包的总容量（ 在本需求中就是本订单中的总单数）
     * Number giftAway.length-- - 物品的种类个数(在本需求中就是满赠信息的数量)
     * Array weight-- - 物品的重量(在本需求中就是各个满赠的初始数量)
     * Array value-- - 物品的价值(在本需求中就是各个满赠的赠品数量）
     */
    if (!orderNum || !giftAway || !giftAway.length) return 0;
    const weight = giftAway.map(item => item.startNum);
    const value = giftAway.map(item => item.giftNum);
    const dp = new Array(giftAway.length + 1).fill(
      new Array(orderNum + 1).fill('')
    );
    var i, j;
    // 为了便于理解,将dp[i][0]和dp[0][j]均置为0，从1开始计算
    for (i = 1; i < giftAway.length + 1; i++) {
      for (j = 1; j < orderNum + 1; j++) {
        // 如果第i件物品的重量大于背包容量j,则不装入背包
        if (weight[i - 1] > j) {
          // 由于weight和value数组下标都是从0开始,故注意第i个物品的重量为weight[i-1],价值为value[i-1]
          dp[i][j] = dp[i - 1][j];
        } else {
          // 这里是与0_1背包最大的区别，就是i不用减一，因为i的数量无限
          dp[i][j] = Math.max(
            dp[i - 1][j],
            dp[i][j - weight[i - 1]] + value[i - 1]
          );
        }
      }
    }
    // 则容量为V的背包能够装入物品的最大值为
    var maxValue = dp[giftAway.length][orderNum];
    j = orderNum;
    var numStr = '';
    for (i = giftAway.length; i > 0; i--) {
      // 若果dp[i][j]>dp[i-1][j],这说明第i件物品是放入背包的
      while (dp[i][j] > dp[i - 1][j]) {
        numStr = i + ' ' + numStr;
        j = j - weight[i - 1];
      }
      if (j === 0) break;
    }
    return maxValue || 0;
  }

  // 计算启动时间
  computeLaunchTime({ mountedTime = 0, skeletonTime = 0, uuid = 0, route }) {
    if (!window || !route) return;
    const launchTime = window.sessionStorage.getItem('appLaunchTime') || 0;
    const webviewTime = route.query.webview_starttime || 0;
    // 客户端白屏时间
    const whiteTime1 =
      launchTime && webviewTime ? +launchTime - +webviewTime : 0;
    if (whiteTime1 <= 0) {
      // 如果<=0，則可能受預加載影響，此次上報作廢
      return;
    }
    // h5白屏时间
    const whiteTime2 = mountedTime - +launchTime;
    // 骨架屏时间 skeletonTime
    const pagePath = route.path || '';
    const params = {
      uuid,
      pagePath,
      webviewTime,
      whiteTime1,
      whiteTime2,
      skeletonTime: skeletonTime - mountedTime
    };
    console.log('记录加载时间（上报）', params);
    // this.nativePie('LOG_EVENT', {
    //   event: 'page_launch_time',
    //   params,
    // })
  }

  // 是否印尼地区
  get isIndonesia() {
    return localStorage.getItem(LocalStorageEventName.region) === 'ID';
  }

  // ios台湾包大陆版
  get isIosCnApp() {
    return localStorage.getItem('STORAGE_VERSION_TAG') === 'milkShake';
  }

  // 是否在 App WebView 中
  get isInAppWebview() {
    let platform = '';
    try {
      platform = localStorage.getItem('STORAGE_PLATFORM');
    } catch (e) {
      // 部分隐私模式下 localStorage 可能不可用，继续通过原生桥判断
    }
    const isAppPlatform = ['2', '3'].includes(String(platform));
    const hasAndroidBridge = !!window.Android;
    const iosGoBackHandler =
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GO_BACK;
    return isAppPlatform || hasAndroidBridge || !!iosGoBackHandler;
  }

  // 结果页返回首页前必须判断实际调用的原生能力，不能只依赖 WebView 标识
  get canUseGoIndex() {
    const androidGoIndex =
      window.Android && typeof window.Android.GO_INDEX === 'function';
    const iosGoIndex =
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GO_INDEX;
    return !!(androidGoIndex || (iosGoIndex && iosGoIndex.postMessage));
  }

  get canUseGoBack() {
    const androidGoBack =
      window.Android && typeof window.Android.GO_BACK === 'function';
    const iosGoBack =
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GO_BACK;
    return !!(androidGoBack || (iosGoBack && typeof iosGoBack.postMessage === 'function'));
  }

  goBack(fallbackPath = '/home') {
    const browserFallback = () => {
      if (window.history && window.history.length > 1) {
        window.history.back();
        return;
      }
      const baseUrl = window.location.href.split('#')[0];
      window.location.replace(`${baseUrl}#${fallbackPath}`);
    };

    if (!this.canUseGoBack) {
      browserFallback();
      return;
    }

    try {
      const result = this.nativePie('GO_BACK');
      if (result && typeof result.catch === 'function') result.catch(browserFallback);
    } catch (error) {
      browserFallback();
    }
  }

  // 判断是否nicee更名为waveeplay后的版本
  get isNewIosApp() {
    return (
      this.isiOS && localStorage.getItem('STORAGE_VERSION_TAG') === 'waveePlay'
    );
  }
  // nicee图标侵权，需更改图标
  get isNewApp() {
    const tag = localStorage.getItem('STORAGE_VERSION_TAG');
    return this.isNewIosApp || (!this.isiOS && tag === 'nicee');
  }

  // 判断是否iOS
  get isiOS() {
    const UA = navigator.userAgent || localStorage.getItem('navigatorUA') || '';
    return !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }

  // 判断是否iPhoneX
  get isiPhoneX() {
    const screen = window.screen || {};
    const innerHeight =
      screen.height || localStorage.getItem('screenHeight') || 0;
    return this.isiOS && innerHeight >= 812 && innerHeight <= 896;
  }

  // 货币单位
  get currencyKind() {
    if (this.isIndonesia) {
      return 'IDR$';
    } else {
      return 'NT$';
    }
  }
  // 判断是否大于该客户端版本号
  // 如果传入数组，则顺序为[iOS_version, android_version]
  onVersion(target) {
    const nowVersion = localStorage.getItem('STORAGE_VERSION');
    // 没有获取到当前版本号，则认为是最新版本or开发环境，返回true
    if (!nowVersion) return true;
    let targetVersion = target;
    if (typeof target === 'object') {
      targetVersion = this.isiOS ? target[0] : target[1];
    }
    const arr1 = nowVersion.split('.').map(item => +item);
    const arr2 = targetVersion.split('.').map(item => +item);
    let result = 0;
    while (arr1.length && arr2.length) {
      const val1 = arr1.shift();
      const val2 = arr2.shift();
      if (val1 === val2) {
        result = 0;
      } else {
        result = val1 > val2 ? 1 : -1;
        break;
      }
    }
    if (result === 0) {
      result = arr1.some(item => item) ? 1 : arr2.some(item => item) ? -1 : 0;
    }
    return result > -1;
  }

  //s核版本
  get RVersion() {
    // return this.isiOS && this.onVersion('1.70.41');
    return false;
  }

  // 根据 key 返回 url 携带的参数（query string 的 val）
  getUrlParam(key, target) {
    let str = target || window.location.href;
    str = str.split('?')[1];
    if (str && str.indexOf(key) !== -1) {
      const pos1 = str.indexOf(key) + key.length + 1;
      const pos2 = str.indexOf('&', pos1);
      const val = pos2 == -1 ? str.substring(pos1) : str.substring(pos1, pos2);
      try {
        return decodeURIComponent(val);
      } catch (e) {
        const len = val.length - 1;
        if (val.substring(len) == '%') {
          return decodeURIComponent(val.substring(0, len)) + '%';
        }
      }
    }
  }

  // 跳转IM聊天
  async toChatPage(param) {
    const { uuid, skillId } = param;
    const { userInfo } = store.getters;
    if (uuid != '250226') {
      if (userInfo && Number(userInfo.uuid) > 4373700) {
        //4383740是測試帳號，跳過驗證
        if (userInfo.uuid != '4383740') {
          const { data } = await $http.get('/im/onBefore');
          if (data === 1) {
            Dialog.confirm({
              message: i18n.t('chat_disable_tip'),
              confirmButtonText: i18n.t('bind_phone_confirm'),
              cancelButtonText: i18n.t('niceebot_21'),
              showCancelButton: true,
              className: 'custom-draw-dialog'
            }).then(() => {
              this.nativePie('PHONE_BIND');
            });
            return;
          }
          if (data === 2) {
            Dialog.confirm({
              message: i18n.t('chat_disable_tip2'),
              confirmButtonText: i18n.t('recharge_confirm'),
              cancelButtonText: i18n.t('niceebot_21'),
              showCancelButton: true,
              className: 'custom-draw-dialog'
            }).then(() => {
              this.nativePie('RECHARGE');
            });
            return;
          }
        }
      }
    }

    const params = this.onVersion('1.15')
      ? {
          ...param,
          uuid: uuid + '',
          skillId: +skillId
        }
      : uuid + '';
    this.nativePie('OPEN_CHAT', params);
  }

  // 统一打开官方客服 QA 首页。
  // App WebView 走 Native Bridge；外部浏览器尝试唤醒 App，失败后提示用户前往应用商店。
  openOfficialCustomerService() {
    const iosHandler =
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.OPEN_OFFICIAL_CUSTOMER;
    const androidHandler =
      window.Android &&
      typeof window.Android.OPEN_OFFICIAL_CUSTOMER === 'function';

    if (iosHandler || androidHandler) {
      return this.nativePie('OPEN_OFFICIAL_CUSTOMER');
    }

    const userAgent = navigator.userAgent || '';
    const isAndroid = /android/i.test(userAgent);
    if (isAndroid || this.isiOS) {
      const startedAt = Date.now();
      let fallbackTimer = null;
      let handleVisibilityChange = null;
      const cleanup = () => {
        if (fallbackTimer) {
          window.clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
        if (handleVisibilityChange) {
          document.removeEventListener(
            'visibilitychange',
            handleVisibilityChange
          );
        }
        window.removeEventListener('pagehide', cleanup);
      };
      handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') cleanup();
      };
      const storeUrl = isAndroid
        ? process.env.VUE_APP_APP_GOOGLE_WEB_URL
        : process.env.VUE_APP_APP_STORE_WEB_URL;

      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pagehide', cleanup);
      fallbackTimer = window.setTimeout(() => {
        const elapsed = Date.now() - startedAt;
        cleanup();
        // 定时器在浏览器后台暂停后可能延迟执行，此时不应误判为唤醒失败。
        if (
          document.visibilityState !== 'visible' ||
          !document.hasFocus() ||
          elapsed >= 5000
        ) {
          return;
        }
        Dialog.confirm({
          message: i18n.t('official_customer_app_open_failed'),
          confirmButtonText: i18n.t('official_customer_go_to_store'),
          cancelButtonText: i18n.t('niceebot_21'),
          showCancelButton: true,
          className: 'custom-draw-dialog official-customer-dialog'
        })
          .then(() => {
            window.location.href = storeUrl;
          })
          .catch(() => {});
      }, 2000);

      window.location.href = isAndroid
        ? 'intent://official-customer' +
          '#Intent;scheme=nicee;package=com.funplus.teamup;end'
        : 'biz.social.weakapp://jump?type=official-customer';
      return Promise.resolve();
    }

    window.location.href = process.env.VUE_APP_NICEE_WEB;
    return Promise.resolve();
  }

  // 去除前后空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }

  // 個位數加0
  repaireZero(val) {
    val += '';
    return val.length > 1 ? val : val.length === 1 ? '0' + val : '';
  }

  // 大數字展示
  repaireLongNum(val) {
    val += '';
    if (val.length < 5) {
      return val;
    } else if (val.length < 9) {
      const pos = val.length - 4;
      return `${val.substring(0, pos)}.${val.substring(pos + 1, pos + 2)}萬`;
    } else {
      const pos = val.length - 9;
      return `${val.substring(0, pos)}.${val.substring(pos + 1, pos + 2)}億`;
    }
  }

  // 千位逗号分隔数字
  moneySplit(money) {
    if (!+money) return 0;
    if (Number.prototype.toLocaleString) {
      return +money.toLocaleString();
    } else {
      return (money + '')
        .split('')
        .reverse()
        .reduce((result, item, index) => {
          const split = index !== 0 && index % 3 == 0 ? ',' : '';
          return item + split + result;
        });
    }
  }

  isOnline(item) {
    // const { skillOnlineStatus } = item;
    // if (skillOnlineStatus) {
    //   return skillOnlineStatus === 'WantOrder'; //积极接单
    // } else {
    //   return this.onlineTime(item) === i18n.t('online');
    // }
    return this.onlineTime(item) === i18n.t('online');
  }

  // 在线時間
  onlineTime({ userOnlineStatus, offlineTime }) {
    if (userOnlineStatus && userOnlineStatus === 'Online') {
      return i18n.t('online');
    } else {
      if (!offlineTime) return i18n.t('online');
      const diff = Date.now() - offlineTime;
      if (diff <= 0) return '';
      const minutes = Math.floor(diff / 60000);
      if (minutes > 480) {
        // 超過8小時，不顯示任何內容
        return '';
      } else if (minutes > 60) {
        // 1-8小時，狀態顯示”x小時前“
        return Math.floor(minutes / 60) + i18n.t('hours_ago');
      } else if (minutes > 0) {
        //   // 30分鐘-1小時，狀態顯示為（關閉的時間-30）分鐘前
        // 1-1小時，線上xx分鍾前
        return minutes + i18n.t('minutes_ago');
      } else {
        return i18n.t('online');
      }
    }
  }

  // 滚动到指定位置
  scrollTo({ target, speed = 20, wrap }) {
    const $wrap = wrap || document.querySelector('#teamup-layout');
    if (speed === 0) {
      if (this.isiOS) {
        $wrap.scrollTo(0, target);
      } else {
        const render = () => {
          $wrap.scrollTo(0, target);
          window.cancelAnimationFrame(render);
        };
        window.requestAnimationFrame(render);
      }
      return;
    }
    const start = $wrap.scrollTop;
    const toTop = start > target;
    let i = 0;
    const easeInOut = (t, b, c, d) => {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    };
    const render = () => {
      const next = Math.floor(
        easeInOut(speed * i, start, toTop ? -start : target * 2, 500)
      );
      if (toTop ? next <= target : next >= target) {
        $wrap.scrollTo(0, target);
        window.cancelAnimationFrame(render);
      } else {
        $wrap.scrollTo(0, next);
        window.requestAnimationFrame(render);
      }
      i++;
    };
    window.requestAnimationFrame(render);
  }
  // 新人優惠券，从 /basic/config 接口获取 newUserCouponPrice 字段
  get newerDiscount() {
    return store.getters.newUserCouponPrice || 0;
  }

  computedPrice(item) {
    let discount = 0;
    const { userInfo, accountInfo } = store.getters;
    if (!userInfo || JSON.stringify(accountInfo) === '{}') {
      discount = this.newerDiscount;
    } else {
      const list = (accountInfo.couponInfoList || []).filter(item => {
        return (
          item.couponTemplate === 'NEWCOMER_EXPERIENCE' &&
          item.couponStatus === 'EFFECT'
        );
      });
      discount = list[0] ? list[0].couponAmount || 0 : 0;
    }
    const { salesPrice, redBagFreeFlag, selfSpreadPrice } = item;
    const { firstOrderPrivilege, firstOrderDiscount } = item;
    if (firstOrderPrivilege) {
      return Math.max(salesPrice - firstOrderDiscount, 0);
    }
    if (discount) {
      const origin = redBagFreeFlag === 1 ? selfSpreadPrice : salesPrice;
      const result =
        origin - discount == salesPrice
          ? ''
          : Math.max(origin - discount, 0) + '';
      if (result) return result;
    }
    return '';
  }

  get tagsList() {
    return [
      {
        id: 11,
        label: i18n.t('gamelol_high_popular')
      },
      {
        id: 15,
        label: i18n.t('gamelol_high_new')
      },
      {
        id: 13,
        label: i18n.t('gamelol_buzzworthy')
      },
      {
        id: 10,
        label: i18n.t('order_completion_king')
      },
      {
        id: 16,
        label: '嚐鮮'
      },
      {
        id: 17,
        label: i18n.t('find_boss')
      },
      {
        id: 28,
        label: i18n.t('gamelol_expert_guiding')
      },
      {
        id: 29,
        label: i18n.t('gamelol_language_support')
      }
    ];
  }

  get gameModelColumn() {
    return [
      {
        value: 'solo',
        text: '單人'
      },
      {
        value: 'solo-fpp',
        text: '單人-fpp'
      },
      {
        value: 'duo',
        text: '雙人'
      },
      {
        value: 'duo-fpp',
        text: '雙人-fpp'
      },
      {
        value: 'squad',
        text: '四人小隊'
      },
      {
        value: 'squad-fpp',
        text: '四人小隊-fpp'
      }
    ];
  }

  computedTags(list, type = 'custom', showNumber = false) {
    // 年度活动标识
    const newYearList = [21, 22, 23, 24, 25, 26, 27];
    if (!list || !list.length) return [];
    const typeRel = {
      custom: {
        10: ['rebought', i18n.t('order_completion_king')],
        11: ['hot', i18n.t('tag_hot')],
        13: ['nice', i18n.t('tag_nice')],
        15: ['new', i18n.t('tag_new')],
        16: ['minutes7', i18n.t('tag_minutes7')],
        // 17: ['findBoss', '小天使團'],
        21: ['championOfYear', i18n.t('dressup_center_7')], // 年度冠军
        22: ['runnerUpOfYear', i18n.t('dressup_center_8')], // 年度亚军
        23: ['thirdPlaceOfYear', i18n.t('dressup_center_9')], // 年度季军
        24: ['bossOfYear', i18n.t('dressup_center_9')], // 年度老板
        25: ['quarterfinalsOfYear', i18n.t('dressup_center_10')], // 年度八强
        26: ['grandCeremony', i18n.t('celebration')], // 盛典
        27: ['hanbokElite', i18n.t('korean_server_elite')], // 韩服精英
        31: ['live', i18n.t('registered_playmate_data_info63')] // 韩服精英
        // 14: ['rebought', '回單王'],
      },
      comment: {
        1001: ['top'], // 上單認證
        1002: ['jug'], // 打野認證
        1003: ['mid'], // 中單認證
        1004: ['adc'], // ADC認證
        1005: ['sup'] // 輔助認證
      }
    };
    const tagRel = typeRel[type];
    if (type === 'comment') {
      // 1024...1028
      // 1055...1059
      for (const id in tagRel) {
        tagRel[+id + 23] = tagRel[id];
        tagRel[+id + 54] = tagRel[id];
      }
    }
    const resolveName = (tag, item) => {
      // if (showNumber && tag[0] == 'rebought' && item.labelData != undefined) {
      //   const subfix = ' ' + Math.round(item.labelData * 100) + '%回購';
      //   // return tag[1] + subfix;
      //   return subfix;
      // }
      return tag[1] || item.labelName;
    };
    return list.reduce((cuur, item) => {
      const id = +item.labelId;
      const tag = tagRel[id];
      let classes = [];
      if (tag) {
        classes = [`${type}-tag`, tag[0]];
        if (newYearList.includes(id)) {
          classes = [...classes, 'only-show-image'];
        }
      }
      return tag
        ? cuur.concat({
            id,
            name: resolveName(tag, item),
            classes: classes,
            onlyShowIamge: newYearList.includes(id)
          })
        : cuur;
    }, []);
  }

  getTagImageList(list) {
    const nList = this.getAllTag(list);
    let srcList = [];
    nList.forEach(item => {
      srcList.push(item.appUrl);
    });
    return srcList;
  }

  getAllTag(list) {
    if (list && list.length) {
      return list.filter(item => {
        return item.showType == 'Default' || item.showType == 'AvatarFrame';
      });
    } else {
      return [];
    }
  }

  /**
   * @description: 獲取不確定值
   */
  getVal(source, keys) {
    if (!keys) return source;
    if (!Array.isArray(keys)) {
      keys = keys.split('.');
    } else {
      keys = [...keys];
    }
    while (keys.length) {
      if (typeof source !== 'object' || !source) return undefined;
      source = source[keys.shift()];
    }
    return source;
  }

  /**
   * @description 上报adjust
   * adjust埋点已失效
   */
  adjust(params) {
    // if (!params || !params.event) {
    //   return;
    // }
    // params.type = 'adjust';
    // params.event = adjustMap[params.event];
    // if (!params.event) {
    //   console.error('adjust 映射为空');
    //   return;
    // }
    // this.nativePie('LOG_EVENT', params);
    return;
  }

  /**
   * @description  比较版本大小
   */
  compareVersion(v1, v2) {
    let cpResult;
    let i = 0;
    const arr1 = v1.replace(/[^0-9.]/, '').split('.');
    const arr2 = v2.replace(/[^0-9.]/, '').split('.');
    while (true) {
      const s1 = arr1[i];
      const s2 = arr2[i++];
      if (s1 === undefined || s2 === undefined) {
        cpResult = arr1.length - arr2.length;
        break;
      }
      if (s1 === s2) continue;
      cpResult = s1 - s2;
      break;
    }
    // eslint-disable-next-line
    return cpResult > 0 ? 1 : cpResult === 0 ? 0 : -1;
  }

  /**
   * 修改url的query而不刷新頁面
   * @param {*} key query key
   * @param {*} value query value
   */
  changeURLParam(key, value) {
    var url = document.URL;
    var resultUrl = '';
    var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
    var r = window.location.hash.split('?')[1].match(reg);
    var replaceText = key + '=' + value;
    if (r != null) {
      var tmp = url.replace(unescape(key + '=' + r[2]), replaceText);
      resultUrl = tmp;
    } else {
      if (url.match('[?]')) {
        resultUrl = url + '&' + replaceText;
      } else {
        resultUrl = url + '?' + replaceText;
      }
    }
    history.replaceState(null, null, resultUrl);
  }
  // 设置图片大小
  setImageSize(url, width, height) {
    if (url) {
      url = url.replace('.gif', '.png');
      return url + `?d=${width}x${height}`;
    } else {
      return '';
    }
  }
  // 重新加载界面
  reloadPage() {
    GlobalAmount(Reload)();
  }

  captureException(errorName, tags, response) {
    MyLog.bugsnagNotify(errorName, {
      tags,
      context: response
    });
  }
  //跳转游戏厅
  toSudGame(roomId, gameId, backgroundUrl, coverUrl, gameType) {
    const obj = {
      roomId: roomId,
      gameId: gameId,
      backgroundUrl: backgroundUrl,
      coverUrl: coverUrl,
      gameType: gameType
    };
    this.nativePie('OPEN_GAME_VOICE_ROOM', obj);
  }
  recharge() {
    if (this.RVersion) {
      this.nativePie('RECHARGECOIN');
    } else {
      this.nativePie('RECHARGE');
    }
  }
  rechargeDiamond() {
    // 印尼单一货币没有钻石，去金币充值
    if (isSingleCoin) {
      this.recharge();
      return;
    }
    if (this.RVersion) {
      this.nativePie('RECHARGEDIANMOND');
    } else {
      this.nativePie('OPEN_WEBVIEW', { targetUrl: '/diamond-recharge' });
    }
  }
}
export default new Base();
